import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../src/components/Pages/Home";
import About from "../src/components/Pages/About";
import Gallery from "../src/components/Pages/Gallery";
import RequestProduct from "../src/components/Pages/RequestProduct";
import NavRounded from "./components/Navbar/Nav";
import Footer from "./components/Footer/Footer";
import AdditionalServices from "./components/Pages/AditionalServices";
import Purchase from "./components/Pages/Purchase";
import Cart from "./components/Pages/Cart";
import Checkout from "./components/Pages/Checkout";
import CompleteCheckout from "./components/Pages/CompleteCheckout";
import N1 from "./components/Pages/N1";
import NotFound from "./components/Pages/NotFound";
import { PRICES } from "./config/prices";
import { CHECKOUT_ENABLED } from "./config/shop";
import { useState } from "react";

function App() {
  const [cart, setCart] = useState(() => {
    try {
      const localCart = JSON.parse(localStorage.getItem("cart"));
      // Drop anything no longer sold (e.g. Tinymen, retired for the N1), or
      // the payment service would reject the whole cart at checkout.
      return Array.isArray(localCart)
        ? localCart.filter((item) => item && PRICES[item.name] !== undefined)
        : [];
    } catch {
      return [];
    }
  });

  return (
    <>
      <NavRounded />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/request-product" element={<RequestProduct />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/additional-services" element={<AdditionalServices />} />
        <Route
          path="/shop"
          element={<Purchase cart={cart} setCart={setCart} />}
        />
        <Route path="/shop/n1" element={<N1 />} />
        {/* With the waiting list on, nothing can be put in a cart, so an old
            bookmark or a cart left in localStorage lands back in the shop. */}
        {CHECKOUT_ENABLED ? (
          <>
            <Route
              path="/cart"
              element={<Cart cartApp={cart} setCartApp={setCart} />}
            />
            <Route path="/checkout" element={<Checkout cart={cart} />} />
          </>
        ) : (
          <>
            <Route path="/cart" element={<Navigate to="/shop" replace />} />
            <Route path="/checkout" element={<Navigate to="/shop" replace />} />
          </>
        )}
        <Route
          path="/complete-checkout"
          element={<CompleteCheckout setCart={setCart} />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
